webpackJsonp([135683008411302],{

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/portsmouth.610ebbd5.jpg";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLanding = function BannerLanding(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "style2 news-banner-wrapper" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major-alt" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Portsmouth, UK"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Having been born and bred in Portsmouth, and having lived here for virtually my entire life, I feel that I\u2019m well placed to know a thing or two about my home town!"
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerLanding;
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerPortsmouth = __webpack_require__(202);
	
	var _BannerPortsmouth2 = _interopRequireDefault(_BannerPortsmouth);
	
	var _portsmouth = __webpack_require__(480);
	
	var _portsmouth2 = _interopRequireDefault(_portsmouth);
	
	var _youtubeEmbedVideo = __webpack_require__(55);
	
	var _youtubeEmbedVideo2 = _interopRequireDefault(_youtubeEmbedVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portsmouth = function Portsmouth(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Portsmouth UK | History | South England'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Portsmouth is one of the most famous port cities in the UK and is located in the South of England in the county of Hampshire. Located just 70 miles  from London, it has a population of just over 200,000 residents and is within easy reach of Southapton.' })
	        ),
	        _react2.default.createElement(_BannerPortsmouth2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'The basics'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'On this page, I thought I\u2019d share with you some of Portsmouth\u2019s fascinating history as well as some of its famous former residents and current attractions and hotspots.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'two', className: 'spotlights' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.visitengland.com/things-to-do/portsmouth', className: 'image', target: '_blank', rel: 'nofollow' },
	                        _react2.default.createElement('img', { src: _portsmouth2.default, alt: 'beautifuly historical portsmouth' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Fascinating history'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Portsmouth\u2019s early history dates back to the Roman times, and as one of the country\u2019s most significant naval ports, Portsmouth has been the focus of shipping in England for centuries.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Home to the oldest dry dock in the world, Portsmouth was a major defence stronghold against the French during the invasion of 1545 and during the 19th century Palmerston Forts were constructed here to protect the coastline from any attack from continental Europe.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'three' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'First mass production line'
	                    ),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Portsmouth is also worthy of note for being the home of the first mass production line anywhere in the world and in World War 2, it was one of the key embarkation points for the D-Day Landings. Although the London Blitz may be well known, many people are unaware that Portsmouth itself suffered from its own Blitz during the war, and almost a thousand people lost their lives.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'HMNB Portsmouth is the Royal Navy\u2019s base and houses two thirds of the surface fleet of the UK. However, the city isn\u2019t all about shipping. In fact, Portsmouth is one of only a handful of cities in Britain to have two cathedrals, while there are numerous local attractions which bring tourists to the area year on year.'
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Famous people from Portsmouth'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Two of the  best known people to have called Portsmouth their birthplace include Charles Dickens, the famous 19th century author, and Isambard Kingdom Brunel, the celebrated 19th century engineer. Creator of Sherlock Holmes, Arthur Conan Doyle also worked in the city as a doctor and even played for Portsmouth Association Football Club in goal! Author of novel The Jungle Book, Rudyard Kipling and H G Wells, the noted historian and novelist also lived here during the 19th century.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'However, not all of Portsmouth\u2019s well known residents are historical figures. Novelist and journalist Christopher Hitchens was born here, while Neil Gaiman, the fantasy author was raised in Southsea. Former prime minister James Callaghan was from the city as was performer Peter Sellars. Perhaps the most unusual former resident of the city is Arnold Schwarzenegger, although a number of actors have spend part of their lives here including Emma Barton, best known for her appearances on Eastenders. '
	                    ),
	                    _react2.default.createElement('hr', null),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Landmarks In Portsmouth'
	                    ),
	                    _react2.default.createElement(_youtubeEmbedVideo2.default, { videoId: 'TEtlXJGL5rU',
	                        suggestions: false,
	                        width: '100%',
	                        height: '450px' }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Portsmouth is home to a number of highly visible landmarks and tourist attractions. Perhaps the best known and most recognisable include the Spinnaker Tower and HMS Warrior, however there are many more interesting sites to explore. The Portsdown Hill Victorian era forts are popular tourist spots with Fort Nelson housing the Royal Armouries Museum. Other interesting museums to visit include the Southsea Castle museum and the Royal Marines Museum at Eastney Barracks as well as the impressive Portsmouth Historic Dockyard where the world famous Tudor-era shipwreck the Mary Rose is housed.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Charles Dickens\u2019 birthplace is also in the city and houses its own museum dedicated to the author and his works, while those with an interest in sealife will appreciate the Blue Reef Aquarium. For those who prefer a spot of retail and window shopping to more cultural attractions, Gunwharf Quays is the perfect destination.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Here, you can find outlet stores, cafes, pubs and enough restaurants to satisfy anyone, and it is here that you\u2019ll find the famous Spinnaker Tower which was constructed back in 2001 and stretches to an impressive height of 560 feet giving outstanding views over the Solent and across to the Isle of Wight. The tower is best known for its glass floor which is the biggest of its kind in Europe and which ways over 33,000 tonnes. '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Another popular tourist spot in the area is the seaside resort of Southsea which lies at Portsea Island\u2019s southern tip. Once a well known southern bathing resort, Southsea today is best known for Southsea Common, the 480 acres of grassland which was created in 1820 when the local marshlands were drained to give the military a clear firing range. Used today for recreational purposes, Southsea Common hosts numerous annual events like carnivals, Victorian festivals and Christmas markets, and is a focal point for the local community. '
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'actions' },
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: '/#header', className: 'button' },
	                                'Back Home'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Portsmouth;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portsmouth-js-4ac5e158af2024095f1c.js